import React, {useContext, useState} from 'react';
import NavBar from '../components/NavBar.jsx';
import 'bootstrap/dist/css/bootstrap.css';
import '../../styles/root/home.css';
import '../../styles/root/homeCards.css';
import {useNavigate, useParams} from "react-router-dom";
import {AuthContext} from "../../config/AuthContext";
import Login from "./Login";
import SeccioMenuCards from "../components/SeccioMenuCards";

export default function Home() {
    const {isLoggedIn, userId, user, actualSite, setActualSite} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const [dades, setDades] = (useState<string>())

    function selectPagina(valor: string) {
        navigate(valor);
    }

    function selectPortada(valor: string, site: string) {
        setActualSite(site);
        navigate(valor);
    }

    // Ens quedem només amb la classe de la imatge de la secció (ecoambit,
    // artiesport, casals...) i traiem el token "caja", que imposava la
    // geometria gegant de les targetes antigues del Home.
    function imageClassOnly(imageclass?: string) {
        return (imageclass || '')
            .split(' ')
            .filter(c => c && c !== 'caja')
            .join(' ');
    }

    // Hi ha opcions al menú "General" (pantalla === 'root')?
    const teMenuGeneral = (user.menus || []).some(
        (m: any) => m.pantalla === 'root' && m.menu && m.menu.length > 0
    );

    if (isLoggedIn) {
        return (
            <>
                <NavBar/>
                <div className="general">
                    <div className="home-cards-wrapper">
                        <div className="home-cards-header">
                            <h2>Inici</h2>
                            <div className="subtitle">Selecciona una secció per començar</div>
                        </div>

                        <div className="home-cards-grid">
                            {user.portada && user.portada.map(value =>
                                <button
                                    className="home-card"
                                    onClick={() => selectPortada(value.enllac, value.nom)}
                                    key={value.nom + value.titol}
                                >
                                    <span className={`home-card-image ${imageClassOnly(value.imageclass)}`}/>
                                    <span className="home-card-label">{value.titol}</span>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Secció "General": mateixes opcions del menú lateral (pantalla root)
                        amb la mateixa iconografia de targetes que Ecoambit/Multilleure.
                        Es mostra com a subsecció (separador tipus "COMANDES"), no com un
                        títol gran com "INICI". */}
                    {teMenuGeneral && (
                        <SeccioMenuCards
                            pantalla="root"
                            titol="General"
                            variant="group"
                        />
                    )}
                </div>
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
}
